import styled from 'styled-components';

const Button = styled.button`
  background: ${({ theme }) => theme.colors.cta};
  color: ${({ theme }) => theme.colors.white};
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
  margin-top: 10px;

  &:hover {
    background: darken(${({ theme }) => theme.colors.cta}, 10%);
  }
`;

function CTAButton({ text, onClick }) {
    return <Button onClick={onClick}>{text}</Button>;
  }
  
  export default CTAButton;